
import React, { } from "react";
import Container from "../../../General/Container/Container";

function WhiteSpaceNewDisplayLegend({ colors, prefixLabel = "Unsaturated", midLabel = "", suffixLabel = "Overly Saturated" }) {
    return (
        <Container className="dcol">
            <Container className="drow justify-between">
                <span className="report--newWhitespace--legend--name">{prefixLabel}</span>
                <span className="report--newWhitespace--legend--name">{midLabel}</span>
                <span className="report--newWhitespace--legend--name">{suffixLabel}</span>
            </Container>
            <Container className="report--newWhitespace--legend">
                {(colors || ["#458A46", "#57AD57", "#7DC97F", "#88898B", "#EF4444", "#DC2626", "#B91C1C"]).map((color) => {
                    return <span className="report--newWhitespace--legend--item" style={{ backgroundColor: color }} />
                })}
            </Container>
        </Container>
    );
}

export default WhiteSpaceNewDisplayLegend;
